import React, { useState } from "react";
import { Toaster } from "react-hot-toast";
import { createTile, updateTile } from "../../API/tile-mgmt";
import { SUCCESS_TOAST, ERROR_TOAST } from "../../helpers/toasters";
import { IKContext, IKUpload } from "imagekitio-react";
import "./addTile.css";
import { imageKitPublicKey, imageKitUrlEndpoint, uri } from "../../helper";

interface AddTileProps {
  handleClose: () => void;
  data?: {
    _id?: string;
    category: string;
    thumbnailUploaded: boolean;
    url: string;
    link?: string;
    status: "active" | "inactive";
    action: boolean;
  };
}

export default function AddTile(props: AddTileProps) {
  const defaultTileState = {
    category: "",
    thumbnailUploaded: false,
    url: "",
    link: "",
    status: "active" as "active" | "inactive",
    action: true,
  };

  const [tileData, setTileData] = useState<any>(
    props.data ? { ...props.data } : defaultTileState
  );
  const [isEditing, setIsEditing] = useState<boolean>(!!props.data?.url);
  const [useImageUpload, setUseImageUpload] = useState<boolean>(true);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type } = e.target;
    setTileData((prev: any) => ({
      ...prev,
      [name]: type === "checkbox" ? (e.target as HTMLInputElement).checked : value,
    }));
  };

  const onError = (err: any) => {
    console.error("Upload Error:", err);
    ERROR_TOAST("Failed to upload thumbnail ❌");
  };

  const onSuccess = (res: any) => {
    setTileData((prev: any) => ({
      ...prev,
      thumbnailUploaded: true,
      url: res.url,
    }));
    SUCCESS_TOAST("Thumbnail uploaded successfully! ✅");
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        ...tileData,
        thumbnailUploaded: !!tileData.url,
      };
      if (isEditing && tileData._id) {
        await updateTile(payload);
        SUCCESS_TOAST("Tile updated successfully! ✅");
      } else {
        await createTile(payload);
        SUCCESS_TOAST("Tile created successfully! ✅");
      }
      props.handleClose();
    } catch (error) {
      console.error("Error saving tile:", error);
      ERROR_TOAST(isEditing ? "Failed to update tile ❌" : "Failed to create tile ❌");
    }
  };

  const handleClose = () => {
    props.handleClose();
  };

  return (
    <>
      <Toaster toastOptions={{ style: { color: "black" } }} />
      <div className="addTile">
        <div className="fullDescTile">
          <div className="headerofAT">
            <h3>{isEditing ? "Edit Tile" : "Add Tile"}</h3>
            <div className="top-svg" onClick={handleClose} style={{ cursor: "pointer" }}>
              {/* SVG code remains unchanged */}
            </div>
          </div>
          <div className="aTile-border-top"></div>
          <div className="ad-body">
            <div className="previous-drop">
              <div className="dropdown">
                <label className="cat-hello" htmlFor="category">Category</label>
                <input
                  type="text"
                  className="form-control setFirst"
                  name="category"
                  value={tileData.category}
                  onChange={handleChange}
                  placeholder="Enter category"
                />
              </div>
              <div className="mx-3">
                <label className="cat-hello mx-1" htmlFor="status">Status</label>
                <div className="radio-child">
                  <label className="align-label px-2">
                    <input
                      type="radio"
                      name="status"
                      checked={tileData.status === "active"}
                      onChange={() => setTileData({ ...tileData, status: "active", action: true })}
                    />
                    <span className="mx-2">Active</span>
                  </label>
                  <label className="align-label px-4">
                    <input
                      type="radio"
                      name="status"
                      checked={tileData.status === "inactive"}
                      onChange={() => setTileData({ ...tileData, status: "inactive", action: false })}
                    />
                    <span className="mx-2">Inactive</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="drag-drop-top-line"></div>
          <div className="upload-drag-drop d-flex justify-content-around flex-column">
            <div >
              <label>Thumbnail Source</label>
              <div className="radio-buttons">
                <label>
                  <input
                    type="radio"
                    checked={useImageUpload}
                    onChange={() => setUseImageUpload(true)}
                  />
                  Upload Image
                </label>
                <label className="mx-3">
                  <input
                    type="radio"
                    checked={!useImageUpload}
                    onChange={() => setUseImageUpload(false)}
                  />
                  Use URL
                </label>
              </div>
            </div>
            {useImageUpload ? (
              <div>
                <label htmlFor="thumbnailUploaded">Thumbnail Upload</label>
                <IKContext
                  publicKey={imageKitPublicKey}
                  urlEndpoint={imageKitUrlEndpoint}
                  authenticationEndpoint={`${uri}/challenge/auth`}
                >
                  <IKUpload
                    fileName={`${tileData.category || "tile"}-${Date.now()}`}
                    onError={onError}
                    onSuccess={onSuccess}
                    className="uploadButton"
                  />
                </IKContext>
              </div>
            ) : (
              <div>
                <label htmlFor="url">Thumbnail URL</label>
                <input
                  type="text"
                  className="form-control"
                  name="url"
                  value={tileData.url}
                  onChange={handleChange}
                  placeholder="Enter thumbnail URL"
                />
              </div>
            )}
            {tileData.url && (
              <p className="mt-2">
                Preview: <a href={tileData.url} target="_blank">View Thumbnail</a>
              </p>
            )}
            <div className="mt-3">
              <label htmlFor="link">Link URL</label>
              <input
                type="text"
                className="form-control"
                name="link"
                value={tileData.link}
                onChange={handleChange}
                placeholder="Enter link URL (e.g., carousel redirect)"
              />
            </div>
          </div>
          <div className="drag-drop-top-line"></div>
          <div className="down-buttons d-flex">
            <button className="create-button" onClick={handleSubmit}>
              {isEditing ? "Update Tile" : "Add Tile"}
            </button>
            <button className="cancel-button" onClick={handleClose}>
              Cancel
            </button>
          </div>
        </div>
      </div >
    </>
  );
}